// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1Emru","label":"SetPasswdForm_label__3EPED"};